export const gapsData = [
  {
    id: 1,
    title: "Knowledge Exists, but Wisdom Doesn’t Scale",
    symptoms: ["Repeated mistakes across projects", "Tribal knowledge", "High dependency on few experts"],
    fit: "Transform experience → structured thinking assets. Capture “why decisions were taken”, not just what was done. Build Living Knowledge Systems for maritime engineering & operations."
  },
  {
    id: 2,
    title: "Root Cause Thinking Is Weak Under Pressure",
    symptoms: ["Equipment failures", "Mission delays", "Cost overruns", "Safety incidents"],
    fit: "Embed decision-quality thinking into project reviews, incident analysis, maintenance planning, safety & HSE workflows. This is embedded cognition, not consulting."
  },
  {
    id: 3,
    title: "Digital Transformation Without Human Transformation",
    symptoms: ["People don’t trust the dashboards", "Decisions still happen in silos", "Data ≠ Insight ≠ Action"],
    fit: "Solve the missing middle: Data → Meaning → Judgment → Decision → Learning. Think5Whys becomes the thinking layer above digital twins, the decision audit trail for AI-assisted systems, and the explainability layer regulators and boards want."
  },
  {
    id: 4,
    title: "ESG, Safety & Compliance Are Compliance-Driven, Not Insight-Driven",
    symptoms: ["Translating ESG into daily behavior", "Proving decision integrity", "Learning from near-misses"],
    fit: "Turn ESG & Safety into decision intelligence. Create traceable reasoning systems. Show why decisions were safe, ethical, sustainable. This is gold for Navies, Port authorities, Offshore operators, Hydrogen & energy projects."
  },
  {
    id: 5,
    title: "Leadership Thinking Fatigue",
    symptoms: ["High-stakes decisions", "Capital-heavy projects", "Long time horizons", "Regulatory pressure"],
    fit: "Build Decision Architectures. Enable scenario stress-testing. Reduce cognitive overload for CXOs with structured thinking support and cognitive load reduction tools."
  }
];

export const layersData = [
  { layer: 1, title: "Decision Infrastructure", items: ["Project decision logs", "Root-cause intelligence", "Failure → learning loops", "Knowledge continuity"], outcome: "Reduced cost overruns, faster learning" },
  { layer: 2, title: "Maritime Workforce Transformation", items: ["Engineers", "Field technicians", "Operations managers", "Safety officers"], methods: ["Micro-learning", "Scenario-based thinking", "Immersive reasoning stories"], outcome: "Faster competence, lower risk" },
  { layer: 3, title: "Think5Whys + DeepTech", items: ["Digital twins", "Hydrogen plants", "Ocean data platforms", "Predictive maintenance systems"], outcome: "Explainable AI + trusted decisions" }
];

export const collaborationModels = [
  { model: "A", title: "Strategic Thinking Partner (Non-Competing)", desc: "You become “The thinking and transformation backbone”. Revenue: Annual platform licensing, Enterprise transformation contracts, Joint government proposals." },
  { model: "B", title: "Joint IP & Thought Leadership", desc: "Co-create Maritime Decision Frameworks, Safety Intelligence Models, Hydrogen project decision playbooks. Monetize via global clients, training academies, government programs." },
  { model: "C", title: "White-Label Think5Whys for Maritime", desc: "“XYZ Company-Powered Decision Intelligence Platform”. Ideal for Defense, PSU, conservative maritime clients." }
];

export const chartData = {
  decisionQuality: {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [{
      label: 'Decision Quality Score',
      data: [65, 72, 78, 85, 88, 92],
      borderColor: '#3b82f6',
      backgroundColor: 'rgba(59, 130, 246, 0.2)',
    }]
  },
  incidentsResolved: {
    labels: ['Q1', 'Q2', 'Q3', 'Q4'],
    datasets: [{
      label: 'Root Causes Institutionalized',
      data: [12, 28, 45, 68],
      backgroundColor: '#1e3a8a',
    }]
  }
};